const validate = (values) => {
  let errors = {};
  if (!values.password) {
    errors.password = 'Required';
  } else if (!values.password.length) {
    errors.password = {_error: 'Please enter a password'};
  }
  if (!values.passwordConfirm) {
    errors.passwordConfirm = 'Required';
  } else if (!values.passwordConfirm.length) {
    errors.password = {_error: 'Please confirm password'};
  } else if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = {_error: 'Password fields must match'};
  }
  else if (values.password.length < 8) {
    errors.password = { _error: 'Password must be at least 8 characters' };
  }
  return errors;
};

export default validate;
